import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Entidad } from '../../model/entidad.model';

@Injectable({
  providedIn: 'root',
})
export class EntidadService {

  constructor(private firestore: AngularFirestore) { }

  public getEntidad(entidadId: string) {
    return this.firestore.collection('entidad').doc(entidadId);
  }


  public getEntidades() {
    return this.firestore.collection('entidad').snapshotChanges();
  }

  createEntidad(entidad: Entidad) {
    return this.firestore.collection('entidad').add(entidad);
  }

  updateEntidad(entidad: Entidad) {
    delete entidad.id;
    this.firestore.doc('entidad/' + entidad.id).update(entidad);
  }

  deleteEntidad(entidadId: string) {
    this.firestore.doc('entidad/' + entidadId).delete();
  }

}
